import React from 'react';
import { cellKey } from '../game/coordinates';
import { hasLighthouse } from '../game/rules';
import { beamCounts } from '../game/visibility';
import LighthouseIcon from './LighthouseIcon';

const territoryNames = [
  'Silver Current',
  'Slate Shoals',
  'Blue Trench',
  'Still Harbor',
  'Storm Reef',
  'Moonlit Reach',
  'Granite Tide',
  'Distant Sound',
];

function SeaBoard({ state, onCellAction, readOnly = false }) {
  const { puzzle, lighthouses } = state;
  const previewBeams = state.previewedLighthouse
    ? beamCounts(puzzle.size, [state.previewedLighthouse])
    : new Map();
  const placementPulse = state.beamFlash
    ? beamCounts(puzzle.size, [state.beamFlash])
    : new Map();
  return (
    <div className={`sea-board${readOnly ? ' sea-board-readonly' : ''}`} role="grid" aria-label="Sea Shroud puzzle board">
      {puzzle.territories.flatMap((territoryRow, row) => (
        territoryRow.map((territory, column) => {
          const key = cellKey(row, column);
          const lighthouse = hasLighthouse(lighthouses, row, column);
          const previewed = previewBeams.has(key);
          const flashing = placementPulse.has(key);
          const rejected = state.feedback?.row === row
            && state.feedback?.column === column
            && state.feedback.type.includes('conflict');
          const label = lighthouse
            ? `Row ${row + 1}, column ${column + 1}, lighthouse in ${territoryNames[territory]}`
            : `Row ${row + 1}, column ${column + 1}, ${territoryNames[territory]}`;

          const Cell = readOnly ? 'div' : 'button';
          const cellProps = readOnly ? {} : { type: 'button', onClick: () => onCellAction(row, column) };
          return (
            <Cell
              {...cellProps}
              role="gridcell"
              key={key}
              className={[
                'sea-cell',
                `territory territory-${territory}`,
                readOnly ? 'read-only' : '',
                previewed ? 'beam-preview' : '',
                flashing ? 'beam-pulse' : '',
                lighthouse ? 'has-lighthouse' : '',
                rejected ? 'rejected' : '',
              ].filter(Boolean).join(' ')}
              aria-label={readOnly
                ? `${label}. ${lighthouse ? 'Solution lighthouse.' : 'No lighthouse.'}`
                : `${label}. ${lighthouse ? state.previewedLighthouse?.row === row && state.previewedLighthouse?.column === column ? 'Remove lighthouse' : 'Preview beams; tap again to remove' : 'Try lighthouse placement'}.`}
            >
              <span className="territory-text" aria-hidden="true">{territory + 1}</span>
              {lighthouse && <LighthouseIcon className="lighthouse-on-board" title={`Lighthouse at row ${row + 1}, column ${column + 1}`} />}
            </Cell>
          );
        })
      ))}
    </div>
  );
}

export default SeaBoard;
